export default __webpack_public_path__ + "static/media/qrcode-sara.ddbcee3a.svg";